import { useQuery, useMutation } from '@tanstack/react-query';
import { DEVICE_QUERIES, DEVICE_MUTATIONS } from '../../infrastructure/device/utils/queries';
import type {
  GetGeoLocationRequest,
  SearchAddressRequest,
  GetAddressDetailsRequest,
  GetPostalCodeRequest,
} from '../../infrastructure/device/utils/types';

export const useDeviceService = () => {
  const useGetGeoLocation = (params: GetGeoLocationRequest) => {
    return useQuery(DEVICE_QUERIES.getGeoLocation(params));
  };

  const useSearchAddress = (params: SearchAddressRequest) => {
    return useQuery(DEVICE_QUERIES.searchAddress(params));
  };

  const useGetAddressDetails = (params: GetAddressDetailsRequest) => {
    return useQuery(DEVICE_QUERIES.getAddressDetails(params));
  };

  const useGetPostalCode = (params: GetPostalCodeRequest) => {
    return useQuery(DEVICE_QUERIES.getPostalCode(params));
  };

  const useGeoLocationMutation = () => {
    return useMutation(DEVICE_MUTATIONS.getGeoLocation());
  };

  const useSearchAddressMutation = () => {
    return useMutation(DEVICE_MUTATIONS.searchAddress());
  };

  const useGetAddressDetailsMutation = () => {
    return useMutation(DEVICE_MUTATIONS.getAddressDetails());
  };

  const useGetPostalCodeMutation = () => {
    return useMutation(DEVICE_MUTATIONS.getPostalCode());
  };

  return {
    /* queries */
    useGetGeoLocation,
    useSearchAddress,
    useGetAddressDetails,
    useGetPostalCode,
    /* mutations */
    useGeoLocationMutation,
    useSearchAddressMutation,
    useGetAddressDetailsMutation,
    useGetPostalCodeMutation,
  };
};
